export default __webpack_public_path__ + "static/media/ans_2.44102ab4.png";